import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

export function NotFound() {
  return (
    <div className="flex flex-col min-h-screen w-full bg-white">
      <SEO
        title="Page Not Found | Axentra Health"
        description="The page you're looking for doesn't exist or has been moved."
        canonicalUrl="/404"
      />

      <Header />

      <main className="min-h-[600px] md:h-[90vh] relative bg-gradient-to-br from-blue-50 to-indigo-100 py-8 md:py-0">
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: "url('/images/404.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
        <div className="relative z-10 h-full flex items-center justify-center px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <h1 className="hero-heading text-6xl font-bold text-[#0F5894] mb-4">
              404
            </h1>
            <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-6">
              Page not found
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
              The page you're looking for doesn't exist.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 mt-10">
              <Link
                to="/"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full text-white bg-[#0F5894] hover:bg-[#0E65AC] transition-colors duration-200"
              >
                Return Home
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-full text-[#0F5894] bg-white hover:bg-gray-50 transition-colors duration-200"
              >
                Contact Support
              </Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
